import 'twin.macro'

import { motion } from 'framer-motion'
import React from 'react'

const Path = props => (
  <motion.path
    fill='transparent'
    strokeWidth='2'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  />
)

const MenuToggle = ({ toggle, isOpen }) => {
  return (
    <button onClick={toggle} tw='relative w-8 h-8 cursor-pointer outline-none border-0 select-none bg-transparent z-50'>
      {isOpen ? (
        <svg xmlns='http://www.w3.org/2000/svg' width={28} height={28} fill='none'>
          <path
            fill='currentColor'
            fillRule='evenodd'
            d='M23.072 4.928a1.167 1.167 0 0 1 0 1.65L6.574 23.077a1.167 1.167 0 0 1-1.65-1.65L21.423 4.928a1.167 1.167 0 0 1 1.65 0'
            clipRule='evenodd'
          />
          <path
            fill='currentColor'
            fillRule='evenodd'
            d='M4.928 4.928a1.167 1.167 0 0 1 1.65 0l16.497 16.497a1.167 1.167 0 0 1-1.65 1.65L4.928 6.578a1.167 1.167 0 0 1 0-1.65'
            clipRule='evenodd'
          />
        </svg>
      ) : (
        <svg width={24} height={25} fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            opacity={0.5}
            d='M3 3.5h18M3 12.5h18M3 21.5h18'
            stroke='currentColor'
            strokeWidth={2}
            strokeLinecap='round'
          />
        </svg>
      )}
    </button>
  )
}

export { MenuToggle }
